export const SPRINT_DEFINITION =
  'A sprint is a focused block of coaching built around one clear goal you set with your coach — for example, mastering a topic, fixing a recurring interview failure mode, or preparing for a specific onsite. It starts after your kickoff call, once you and your coach have agreed on the goal and how you will measure progress against it.'

/**
 * PostHog flag gating the public marketing pages (/about, /how-it-works,
 * /pricing) and every nav surface that links to them. Created manually in
 * the PostHog UI, and it must EXIST there for the off state to behave
 * fully: nav links stay hidden either way, but if the flag is missing
 * useFeatureFlag never resolves (isLoaded stays false), so gated pages
 * show a loading state instead of redirecting to /. Create the flag
 * (disabled) before deploying this code.
 */
export const MARKETING_PAGES_FLAG = 'enable-marketing-pages'
